import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Stepper } from '@modernhealth/vital-components';

import { CareNavigationStepper } from '../models/testsIds';

const StepperContainer = styled.div({
    width: '100%',
});

interface Props {
    step: number;
}

export const CareNavigationSteps: React.FC<Props> = ({ step }) => {
    const { t } = useTranslation();
    const shortNames = [
        t('benefits:care_navigation_stepper.topic'),
        t('benefits:care_navigation_stepper.details'),
        t('benefits:care_navigation_stepper.contact_method'),
        t('benefits:care_navigation_stepper.contact_information'),
    ];
    return (
        <StepperContainer>
            <Stepper
                formatNextStep={() =>
                    t('benefits:care_navigation_steps.next', { stepName: shortNames[step] })
                }
                label={t('benefits:care_navigation_steps.current_step', {
                    currentStep: step,
                    totalSteps: shortNames.length,
                })}
                shortNames={shortNames}
                step={step}
                testID={CareNavigationStepper.Wrapper}
            />
        </StepperContainer>
    );
};
